import { render, staticRenderFns } from "./ktButton.vue?vue&type=template&id=15b7b718"
import script from "./ktButton.vue?vue&type=script&lang=js"
export * from "./ktButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports